<template>
  <div id="root">
    <v-overlay :value="isLoading" color="#565656">
      <v-progress-circular indeterminate size="64" color="565656"></v-progress-circular>
    </v-overlay>
    <div id="popupContainer" />
    <div id="contentContainer">
      <div id="title">{{this.title}}</div>
      <div id="caption" v-html="this.caption"></div>
      <div v-if="this.mode === 'confirm'">
        <div id="confirmButton" @click="onConfirmButton">확인</div>
      </div>
      <div v-if="this.mode === 'delete'" class="deleteButtonContainer">
        <div class="cancelButton" @click="onConfirmButton">취소</div>
        <div class="deleteButton" @click="onDeleteButton">삭제</div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapMutations} from "vuex";
import {api} from "../../../mixins/api";

export default {
  name: "PopupDialogComponent",
  props: {
    title: {
      type: String,
      default() {
        return "로그인에 실패했습니다.";
      }
    },
    caption: {
      type: String,
      default() {
        return "이메일 또는 비밀번호를 확인해주세요.";
      }
    },
    mode: {
      type: String,
      default() {
        return "confirm"
      }
    },
    siteId: {
      type: Number,
      default() {
        return -1;
      }
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapMutations(["setShowHyundaiLoginFailedPopup", "setKakaoAddressInfo"]),
    onConfirmButton() {
      this.setShowHyundaiLoginFailedPopup(false);
    },
    async onDeleteButton() {
      if (this.siteId === -1) {
        alert('siteId가 없습니다.');
        return;
      }

      this.isLoading = true;

      await api.methods.deleteHdecBusinessSite(this.siteId);
      this.isLoading = false;
      this.setKakaoAddressInfo({});

      this.setShowHyundaiLoginFailedPopup(false);
      this.$router.replace('/hyundai/create');
    }
  }
}
</script>

<style scoped>
#root {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: HDharmony, sans-serif;
}

#popupContainer
{
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  background: #000000;
  opacity: 0.6;
}

#contentContainer {
  width: 461px;
  height: 230px;
  background: #FFFFFF;
  border-radius: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
#title {
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.6px;
  color: #333333;
  margin-bottom: 16px;
}

#caption {
  font-size: 16px;
  text-align: center;
  letter-spacing: -0.6px;
  color: #A5A5A5;
  margin-bottom: 28px;
  line-height: 24px;
}

#confirmButton {
  width: 151px;
  height: 50px;
  background: #333333;
  border-radius: 100px;

  text-align: center;
  letter-spacing: -0.6px;
  color: #FFFFFF;
  font-size: 18px;
  line-height: 18px;
  padding-top: 16px;
}

#confirmButton:hover {
  cursor: pointer;
}

.deleteButtonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancelButton {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
  color: #333333;
  background: #FFFFFF;
  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 100px;
  padding: 16px 60px;
}

.deleteButton {
  margin-left: 16px;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.6px;
  color: #FFFFFF;
  background: #333333;
  border-radius: 100px;
  padding: 16px 60px;
}

.cancelButton:hover, .deleteButton:hover {
  cursor: pointer;
}

</style>
